<style scoped>
  .modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>

<template>
  <div>
    <div class="modal-backdrop show"></div>
    <div class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('upload_image') }}</h5>
            <button type="button" class="close outline-none" @click="$emit('close')">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </span>  
            </button>
          </div>
          <div class="modal-body">
            <label for="uploadImage" class="required center">{{ $t('image') }}</label>
            <app-input  id="uploadImage"
                        type="custom-file-upload"
                        :generate-file-url="false"
                        v-model="selectedFile"
                        :label="$t('upload_image')"
                        @change="onFileSelected"
                        />
            <br>  
            <label for="description" class="required center">{{ $t('description') }}</label>          
            <app-input 
              id="description"
              type="text"
              v-model="descriptionFile"
              placeholder="file description"
            />            
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('close')">
              Close
            </button>
            &nbsp;
            <button type="button" class="btn btn-primary" @click="uploadImage" :disabled="!selectedFile">
              Save
            </button>
            <p v-if="uploadStatus">{{ uploadStatus }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedFile: null,
      uploadStatus: '',
      uploadResponse: false,
      descriptionFile : '',
    };
  },
  methods: {
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
    },
    async uploadImage() {
      if (!this.selectedFile) {
        this.$toastr.w("Image required");
        return;
      };
      if (!this.descriptionFile) {
        this.$toastr.w("Description required");
        return
      }; 

      this.uploadStatus = 'Subiendo...';
      const formData = new FormData();
      formData.append('description', this.descriptionFile);
      formData.append('image', this.selectedFile);

      try {
        const response = await axios.post('/upload-images/store', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.uploadStatus = response.data.message;
        this.uploadResponse = response.data.status;

        if (this.uploadResponse) {
          this.$emit('image-uploaded'); 
        }
      } catch (error) {
        this.uploadStatus = 'Error al subir: ' + (error.response?.data?.message || error.message);
      }
    }
  }
};
</script>